import React from 'react';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Heading from '@marvelapp/marvel-ui/heading';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import Image from 'marketing-website/components/modules/Image';
import Page from 'marketing-website/components/modules/Page';
import TickedCopy from 'marketing-website/components/modules/TickedCopy';
import WebinarForm from 'marketing-website/components/modules/WebinarForm';

import assets from 'marketing-website/configs/pages/ebook-design-systems/assets.js';
import metaData from 'marketing-website/data/metadata.js';
import { formEbookDesignSystems } from 'marketing-website/configs/hubspot';

import learnings from 'marketing-website/configs/pages/ebook-design-systems/learnings.js';
import styles from './style/general.module.css';
import LandingPagesWrap from '../../components/modules/LandingPagesWrap';

const meta = {
  title: metaData['ebook-design-systems'].title,
  meta: [
    {
      name: 'description',
      content: metaData['ebook-design-systems'].description,
    },
  ],
  header: false,
  footer: true,
};

const messaging = {
  header: (
    <Spacing type="margin" size="xs" position="bottom">
      <Heading tag="h1" size="xxl" weight="semibold">
        Download the eBook, for free!
      </Heading>
    </Spacing>
  ),
  copy: (
    <Spacing type="margin" size="l" position="bottom">
      <Paragraph size="m" color="silver">
        Simply fill out your details below to grab your copy of the eBook.
      </Paragraph>
    </Spacing>
  ),
};

export default function EbookDesignSystems() {
  return (
    <Page {...meta}>
      <LandingPagesWrap color={'black'}>
        <div id="enterprise-form" style={{ backgroundColor: '#FCE0D4' }}>
          <PageWrap>
            <Spacing size="xl" position="top" type="padding">
              <Spacing size="xl" position="topBottom" type="padding">
                <Grid columns={12} alignContent="center">
                  <GridItem columnSpan={12} columnSpanM={6}>
                    <Spacing type="margin" size="s" position="bottom">
                      <HeadingBlock
                        justifyM="start"
                        headingSize="xxxxl"
                        paragraphSize="xxl"
                        paragraphMaxWidth={600}
                        headingMaxWidth={600}
                        title="Getting Started with Design Systems"
                        copy={
                          <span>
                            A free guide that's simple in structure, human in
                            explanation and packed with insight
                          </span>
                        }
                      />
                    </Spacing>

                    <div className={styles.imageEbookHero}>
                      <Image {...assets.hero} useImageTag />
                    </div>

                    <Spacing type="padding" position="topBottom" size="m">
                      <HeadingBlock
                        justifyM="start"
                        headingSize="xxl"
                        paragraphMaxWidth={600}
                        headingMaxWidth={450}
                        title="What does it take to build a Design System? "
                        copy={
                          <span>
                            They've been proven to help teams drive faster
                            development, eliminate inconsistency, save money and
                            reduce knowledge silos. Un-arguably, it's a win-win
                            situation. But how do you get started? We're proud
                            to present an introductory guide to Design Systems,
                            created to remove the overwhelming overhead a task
                            like this can have.
                          </span>
                        }
                      />
                    </Spacing>
                  </GridItem>

                  <GridItem columnSpan={12} columnSpanM={6} fullWidth>
                    <div className={styles.formPosition}>
                      <div className={styles.formBorder}>
                        <div className={styles.formPadding}>
                          <WebinarForm
                            headerTitle={messaging.header}
                            headerText={messaging.copy}
                            btnColor="blue"
                            ctaCopy="Download the eBook"
                            infoMessage="Download the eBook"
                            hubspotId={formEbookDesignSystems}
                            url={
                              '/resources/thanks-for-downloading-getting-started-how-to-build-design-system'
                            }
                            disallowedFields={['phoneNumber']}
                          />
                        </div>
                      </div>
                    </div>
                  </GridItem>
                </Grid>
                <Grid columns={12}>
                  <GridItem columnSpan={12} columnSpanM={6}>
                    <MaxWidth value={600}>
                      <div className="paddingTop-l">
                        <Spacing type="margin" position="topBottom" size="m">
                          <Heading tag="h2" size="xxl" weight="semibold">
                            What you'll learn:
                          </Heading>
                        </Spacing>
                      </div>
                      {learnings.map(item => (
                        <Spacing type="padding" position="bottom" size="s">
                          <TickedCopy
                            isCentered={false}
                            key={item.id}
                            size="l"
                            shouldShowBlackTick
                          >
                            {item.text}
                          </TickedCopy>
                        </Spacing>
                      ))}
                    </MaxWidth>
                  </GridItem>
                  <GridItem columnSpan={12} columnSpanM={6}>
                    <div className={styles.imageEbookBottom}>
                      <Image {...assets.second} useImageTag />
                    </div>
                  </GridItem>
                </Grid>
              </Spacing>
            </Spacing>
          </PageWrap>
        </div>
      </LandingPagesWrap>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/ebook-design-systems/index.js